export const DISPLAY_NOTIFICATION = 'DISPLAY_NOTIFICATION';
export const CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION';

export const Position = {
  top_left: 'top-left',
  top_right: 'top-right',
  top_center: 'top-center',
  bottom_left: 'bottom-left',
  bottom_right: 'bottom-right',
  bottom_center: 'bottom-center',
};

export const NotificationType = {
  danger: 'danger',
  warning: 'warning',
  info: 'info',
  success: 'success',
};

export const PERMISSION_TOAST_AUTO_DISMISS_MS = 3000;

export const PW = {
  container: 'notification:container',
  permissionToast: 'scheduler:permission-toast',
  permissionToastClose: 'scheduler:permission-toast:close',
  permissionToastMessage: 'scheduler:permission-toast:message',
  alert: 'notification:alert',
  alertClose: 'notification:alert:close',
  alertMessage: 'notification:alert:message',
};

export const defaultState = {
  listOfNotifications: [],
  maxNumberOfNotifications: 5,
  showNotifications: false,
};
